import React, { useCallback } from "react";
import { type CompareV2DispatchType, useCompareV2Selector } from "../../redux/store";
import { getCarPriceAndCarIdForEngine } from "../../utils/formatters/priceAndEcoSpecsFormatters";
import PdfLink from "./PdfLink";
import * as CompareStyles from "./styles/CompareStyles";
import * as CompareItemStyles from "./styles/CompareItem";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { CompareV2Label } from "../../utils/labels";
import {
    getAEMBuildPage,
    getAEMGradePage,
    getAEMModelPage,
} from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import CompareTable from "../common/CompareTable";
import { trackCompareCta } from "../../utils/tracking";
import { showModal } from "../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_DELETE_CAR } from "../../../../shared-logic/features/compare/utils/modalConstants";
import { CompareV2Mode } from "../../../../shared-logic/features/compare/utils/types";
import ButtonPrimary from "../../../../common-deprecated/components/aem/toyota/ButtonPrimary";
import ButtonSecondary from "../../../../common-deprecated/components/aem/toyota/ButtonSecondary";
import { CarDBModelId, THEME_CLASSNAME_BZ } from "../../../../common-deprecated/constants";
import ButtonQuaternary from "../../../../common-deprecated/components/aem/toyota/ButtonQuaternary";
import { NcCompareContext } from "../../../../common-deprecated/types/NewCarCompareTypes";
import { useDispatch } from "../../../../shared-logic/redux/store";

const CtaContainer = (): JSX.Element => {
    const dispatch = useDispatch<CompareV2DispatchType>();

    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const selectedEngines = useCompareV2Selector((state) => state.newCarCompare.selectedEngines);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const isLeasing = useCompareV2Selector(
        (state) => state.newCarCompare.ncCompareContext === NcCompareContext.Leasing,
    );
    const financeProduct = useCompareV2Selector((state) => state.newCarCompareExternalData.financeProduct);
    const getLeasingUrl = useCallback(
        (configUrl: string | undefined) => {
            if (!configUrl) return undefined;
            if (!financeProduct) return configUrl;
            return `${configUrl}${configUrl.includes("?") ? "&" : "?"}financeProduct=${financeProduct}`;
        },
        [financeProduct],
    );

    const carPricesAndCarIds = getCarPriceAndCarIdForEngine(cars, selectedEngines);

    return (
        <>
            <CompareTable
                items={cars}
                columnChild={(car, index) => (
                    // Not using getThemeClassname util here as professional-theme should not apply to compare columns
                    <CompareItemStyles.Wrapper
                        className={car.modelId === CarDBModelId.BZ4X ? THEME_CLASSNAME_BZ : undefined}
                    >
                        <CompareStyles.Actions>
                            {isLeasing ? (
                                <ButtonPrimary
                                    fullWidth
                                    href={getLeasingUrl(car.configuration?.link)}
                                    onClick={() => trackCompareCta("lease-detail")}
                                >
                                    <CompareV2Label label="compareBodyCtaPersonalise" />
                                </ButtonPrimary>
                            ) : (
                                <>
                                    <ButtonPrimary
                                        fullWidth
                                        href={
                                            getAEMGradePage(
                                                commonSettings,
                                                car.modelId,
                                                car.colourCode,
                                                carPricesAndCarIds[index].carId,
                                            ) || getAEMModelPage(commonSettings, car.modelId)
                                        }
                                        onClick={() => trackCompareCta("view-car-details")}
                                    >
                                        <CompareV2Label label="compareBodyCtaExploreGrade" />
                                    </ButtonPrimary>
                                    <ButtonSecondary
                                        fullWidth
                                        href={getAEMBuildPage(
                                            commonSettings,
                                            car.modelId,
                                            car.colourCode,
                                            carPricesAndCarIds[index].carId,
                                            car.availableColours,
                                        )}
                                        rel="nofollow"
                                        onClick={() => trackCompareCta("carconfigurator")}
                                    >
                                        <CompareV2Label label="compareBodyCtaPersonalise" />
                                    </ButtonSecondary>
                                </>
                            )}
                            <ButtonQuaternary
                                onClick={() => {
                                    dispatch(
                                        showModal({
                                            type: MODAL_DELETE_CAR,
                                            mode: CompareV2Mode.New,
                                            indexToDelete: index,
                                        }),
                                    );
                                }}
                                hasIcon
                            >
                                <Icon variant="close" />
                                <CompareV2Label label="compareBodyRemoveCar" />
                            </ButtonQuaternary>
                        </CompareStyles.Actions>
                    </CompareItemStyles.Wrapper>
                )}
            />
            <PdfLink />
        </>
    );
};

export default CtaContainer;
